import React, { ReactNode, Component } from "react";

import Title from "./Title";

import {
  Container,
  Content,
  TopControlsContainer,
  TopControlsToolbar,
  Loader,
} from "./styles";

export type Props = {
  title?: string;
  children: ReactNode;

  controls?: ReactNode;
  leftControls?: ReactNode;
  isLoading?: boolean;
  className?: any;
  topControls?: ReactNode;
};

export default class Page extends Component<Props> {
  render() {
    const {
      title,
      controls,
      children,
      isLoading,
      className,
      leftControls,
      topControls,
    } = this.props;

    return (
      <>
        {topControls && (
          <TopControlsContainer elevation={0}>
            <TopControlsToolbar>{topControls}</TopControlsToolbar>
          </TopControlsContainer>
        )}

        <Container className={className} withTopControls={!!topControls}>
          {title && (
            <Title
              title={title}
              leftControls={leftControls}
              controls={controls}
            />
          )}
          {isLoading ? <Loader /> : <Content>{children}</Content>}
        </Container>
      </>
    );
  }
}
